import { useAuth } from '@/contexts/AuthContext';
import ProtectedRoute from './ProtectedRoute';

// Trading features - accessible to all authenticated users
// The chart and basic trading features should always be available
export default function TradingProtectedRoute({ children }) {
  const { loading } = useAuth();
  
  // Still loading - show spinner
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  
  // Wrap in ProtectedRoute to ensure authentication only
  // All authenticated users can access the trading terminal
  return <ProtectedRoute>{children}</ProtectedRoute>;
}
